import lib from "zeta-dom";
const { EventContainer, EventSource } = lib;
export { EventContainer as ZetaEventContainer, EventSource as ZetaEventSource };